
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getProductInfo } from '@/api/product/productAccount'
import { setProductInfo } from '@/api/product/product'

@Component({
  name: 'IndiaH5Extra',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any

  private extraParam: any = {
    amount_timeout: null
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  private async noExtraUpdate() {
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        amount_timeout: this.extraParam.amount_timeout
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 产品详情
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      if (res.extra_param.amount_timeout) {
        this.extraParam.amount_timeout = res.extra_param.amount_timeout
      } else {
        this.extraParam.amount_timeout = ''
      }
    })
  }

  mounted() {
    this.getInfo()
  }
}
